function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "transistor");

var SvgTransistor = function SvgTransistor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b54d9b58-bf4e-46a7-a019-c4174b704f38",
    "data-name": "Ebene 1",
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 123.59,
    y: 176.55,
    width: 264.83,
    height: 35.31,
    rx: 8.83,
    style: {
      fill: "#894b9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.9,0H353.1a17.66,17.66,0,0,1,17.66,17.66h0V176.55H141.24V17.66A17.66,17.66,0,0,1,158.9,0Z",
    style: {
      fill: "#955ba5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.55,61.79A8.83,8.83,0,0,1,167.72,53V35.31a8.83,8.83,0,1,1,17.66,0V53A8.82,8.82,0,0,1,176.55,61.79Z",
    style: {
      fill: "#b49aca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.55,150.07a8.83,8.83,0,0,1-8.83-8.83h0v-53a8.83,8.83,0,1,1,17.66,0v53a8.83,8.83,0,0,1-8.83,8.83Z",
    style: {
      fill: "#b49aca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.9,211.86h35.31V503.17a8.83,8.83,0,0,1-8.83,8.83H167.72a8.82,8.82,0,0,1-8.82-8.82h0Z",
    style: {
      fill: "#95a5a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.34,211.86h35.32V503.17a8.83,8.83,0,0,1-8.83,8.83H247.17a8.83,8.83,0,0,1-8.83-8.83Z",
    style: {
      fill: "#95a5a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.79,211.86H353.1V503.17a8.82,8.82,0,0,1-8.81,8.83H326.62a8.83,8.83,0,0,1-8.83-8.83Z",
    style: {
      fill: "#95a5a5"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTransistor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transistor.54b31058.svg";
export { ForwardRef as ReactComponent };